import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Navbar } from './Components/Navbar/Navbar';
import Home from './Pages/Home';
import Projects from './Pages/ProjectsPage';
import About from './Pages/AboutPage';
import Resume from './Pages/Resume';
import Contact from './Components/Contact/Contact';

function App() {
  return (
    <Router>
      <div className="app-bg">
        <Navbar />
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/projects' element={<Projects/>} />
          <Route path='/about' element={<About/>} />
          <Route path='/resume' element={<Resume/>} />
          <Route path='/contact' element={<Contact/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
